export function rotate(
  absolutePoint,
  status,
  currentItemView,
  ...args
) {
  if (status !== 'rotation') return false

  if (!args[2]) return false
  const { axisX, axisY } = args[2]
  if (axisX === undefined || axisY === undefined) return false

  //sides of a triangle
  const a =
    ((absolutePoint.x - currentItemView.boundary.x - currentItemView.boundary.width / 2) ** 2 +
      (absolutePoint.y - currentItemView.boundary.y - currentItemView.boundary.height / 2) ** 2) **
    (1 / 2)
  const b =
    ((axisX * currentItemView.boundary.width - currentItemView.boundary.width / 2) ** 2 +
      (axisY * currentItemView.boundary.height - currentItemView.boundary.height / 2) ** 2) **
    (1 / 2)
  const c =
    ((absolutePoint.x - (currentItemView.boundary.x + axisX * currentItemView.boundary.width)) **
      2 +
      (absolutePoint.y - (currentItemView.boundary.y + axisY * currentItemView.boundary.height)) **
        2) **
    (1 / 2)

  const angle = Math.acos((a ** 2 + b ** 2 - c ** 2) / (2 * a * b))

  //equation for diagonal: y = ka * x + kb
  const ka = currentItemView.boundary.height / currentItemView.boundary.width
  const kb =
    currentItemView.boundary.y -
    (currentItemView.boundary.x * currentItemView.boundary.height) / currentItemView.boundary.width

  const y1 = ka * absolutePoint.x + kb
  const x2 = (absolutePoint.y - kb) / ka

  //change angle of rotation for current itemView
  if (y1 >= absolutePoint.y && x2 <= absolutePoint.x) currentItemView.boundary.angle = angle
  else currentItemView.boundary.angle = -angle

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/rotate.js